export default {
  name: 'CoreChartFitText',
  props: {
    value: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    classFontFamily() {
      return this.$store.state.app.useAltFonts ? 'roboto' : 'poppins';
    }
  },
  watch: {
    value() {
      this.$nextTick(() => {
        this.fitText();
      });
    }
  },
  mounted() {
    this.fitText();
  },
  methods: {
    isOverflown(element) {
      return element.scrollWidth > element.clientWidth;
    },
    fitText() {
      const MAX_FONT_SIZE = 36;
      const MIN_FONT_SIZE = 16;
      let fontSize = MAX_FONT_SIZE;
      let overflow = this.isOverflown(this.$el);

      // Decrease font-size until it fits or min font-size is reached
      while (overflow && fontSize >= MIN_FONT_SIZE) {
        this.$refs.text.style.cssText = `font-size: ${fontSize}px !important`;
        overflow = this.isOverflown(this.$el);
        fontSize--;
      }
      this.$refs.text.style.cssText = `font-size: ${fontSize}px !important`;
    }
  }
};